module.exports = __webpack_public_path__ + "static/media/draggable.8500fdc3.svg";